var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.755,
    height: 22.378,
    viewBox: "0 0 42.755 22.378"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3258",
    "data-name": "Group 3258",
    transform: "translate(41.341 -19.62) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron-right_2_",
    "data-name": "chevron-right (2)",
    d: "M9,45.927,28.963,25.963,9,6",
    transform: "translate(12.034 -6)",
    fill: "none",
    stroke: "#191818",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0Mi43NTUiIGhlaWdodD0iMjIuMzc4IiB2aWV3Qm94PSIwIDAgNDIuNzU1IDIyLjM3OCI+CiAgPGcgaWQ9Ikdyb3VwXzMyNTgiIGRhdGEtbmFtZT0iR3JvdXAgMzI1OCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDEuMzQxIC0xOS42Mikgcm90YXRlKDkwKSI+CiAgICA8cGF0aCBpZD0iY2hldnJvbi1yaWdodF8yXyIgZGF0YS1uYW1lPSJjaGV2cm9uLXJpZ2h0ICgyKSIgZD0iTTksNDUuOTI3LDI4Ljk2MywyNS45NjMsOSw2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMi4wMzQgLTYpIiBmaWxsPSJub25lIiBzdHJva2U9IiMxOTE4MTgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgChevron as ReactComponent };